import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HashRouter } from "react-router-dom";
import DataProvider from "./components/store/DataProvider";
import NavigationProvider from "./components/store/NavigationProvider";
import CartProvider from "./components/store/CartProvider";
import { ErrorBoundary } from "react-error-boundary";
import ErrorBoundaryFallback from "./components/Other/ErrorBoundaryFallback";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary
      FallbackComponent={ErrorBoundaryFallback}
      onReset={() => {
        window.location.reload();
      }}
    >
      <NavigationProvider>
        <HashRouter hashType="hashbang">
          <DataProvider>
            <CartProvider>
              <App />
            </CartProvider>
          </DataProvider>
        </HashRouter>
      </NavigationProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
